import { MotivationPrinciple } from "@oldDashboard/legacyModels/motivationPrinciple.model";
import { MotivationPrincipleSerializer } from "@oldDashboard/legacyModels/serializers/motivationPrincipleSerializer";
import { legacyReportingGet } from "@oldDashboard/legacyUtils";

export class CommandMotivationPrinciples {

    async run(affiliateId: String, launchSelected: String, timePeriodSelected: String, startDate: String, endDate: String) {  
        const path = `get-chart-data/client:impressions-distribution-by-objective/?affiliate_id=${affiliateId}&launch_id=${launchSelected}&time_period=${timePeriodSelected}&start_date=${startDate}&end_date=${endDate}`
        try {
            const response = await legacyReportingGet(path);
            if(response.success)
                return this.deserialize(response.chart_data.series_data[0].data);
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    deserialize(data: any) : MotivationPrinciple[] {
        const serializer = new MotivationPrincipleSerializer();
        return serializer.deserializeList(data);
    }
}

